export type AuditLogNotePart =
  | { type: 'text'; value: string }
  | { type: 'link'; label: string; url: string };

const MARKDOWN_LINK_REGEX = /\[([^\]]+)\]\(([^)]+)\)/g;

export const WORKER_PROFILE_PATH_REGEX = /^\/workers\/([^/?#]+)$/;

export const parseWorkerIdFromProfilePath = (url: string): string | null => {
  const match = url.match(WORKER_PROFILE_PATH_REGEX);
  return match?.[1] ?? null;
};

export const parseAuditLogNotes = (notes: string): AuditLogNotePart[] => {
  const parts: AuditLogNotePart[] = [];
  let lastIndex = 0;

  for (const match of notes.matchAll(MARKDOWN_LINK_REGEX)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      parts.push({ type: 'text', value: notes.slice(lastIndex, matchIndex) });
    }
    parts.push({ type: 'link', label: match[1], url: match[2] });
    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < notes.length) {
    parts.push({ type: 'text', value: notes.slice(lastIndex) });
  }

  if (parts.length === 0) {
    parts.push({ type: 'text', value: notes });
  }

  return parts;
};
